import { createStyles, makeStyles } from "@material-ui/core";
import { theme } from "config/theme";

export const useOrderStyles = makeStyles(() =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      height: "68vh",
      [theme.breakpoints.down("xs")]: { overflowY: "scroll" },
    },
    rootContent: {
      height: "auto",
      display: "flex",
      flexDirection: "column",
      background: "#fff",
      borderRadius: 14,
      padding: 20,
      overflowX: "auto",
      [theme.breakpoints.down("xs")]: { paddingTop: "6px", marginLeft: "15px" },
    },
    title: {
      paddingBottom: 20,
      textTransform: "capitalize",
    },
    line: {
      display: "flex",
      justifyContent: "space-between",
      paddingBottom: 20,
    },
    ordersDisplay: {
      display: "flex",
      flexFlow: "wrap",
      justifyContent: "center",
      position: "relative",
      flexBasis: "auto",
      justifyItems: "center",
      [theme.breakpoints.down("xs")]: {
        left: -21,
      },
    },
    buttons: {
      display: "flex",
      textAlign: "end",
      marginRight: 20,
      padding: "24px",
      justifyContent: "end",
      marginTop: "40px",
      [theme.breakpoints.down("xs")]: {
        paddingRight: "47px",
        paddingBottom: "40px",
        paddingLeft: "17px",
      },
    },
    previousOrderList: {
      "&.MuiButton-root": {
        width: "160px",
        margin: "-9px",
      },
      marginTop: "5px",
      [theme.breakpoints.down("xs")]: {
        marginTop: "6px",
      },
    },

    jobType: {
      fontSize: 18,
      fontWeight: 500,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
      color: "#787878",
      [theme.breakpoints.down("xs")]: { position: "relative", left: -17, fontSize: "14px" },
    },
    step: {
      fontSize: 20,
      fontWeight: 900,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
      color: "#399ebf",
      [theme.breakpoints.down("xs")]: { position: "relative", left: -21 },
    },
    orderTextInfo: {
      width: "232px",
      height: "34px",
      margin: "11px 85px 156px -20px",
      fontFamily: "Montserrat",
      fontSize: "14px",
      fontWeight: "bold",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
      textAlign: "center",
      color: "#757a93",
    },
    deleteBtn: {
      border: "1px solid",
      padding: "10px 15px",
      borderRadius: "4px",
      color: "#757a93",
      marginLeft: "18px",
      [theme.breakpoints.down("xs")]: {
        width: "185px",
        left: "40px",
      },
    },
    delete: {
      [theme.breakpoints.down("xs")]: {
        position: "relative",
        top: -32,
      },
    },
    addOrderDesc: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      [theme.breakpoints.down("xs")]: {
        flexDirection: "column",
        alignItems: "baseline",
        marginRight: "8px",
      },
    },
    addOrder: {
      marginTop: -37,
      display: "flex",
      justifyContent: "flex-end",
    },
    orderIcon: {
      marginRight: "-187px",
      marginTop: "15px",
      [theme.breakpoints.down("xs")]: {
        position: "relative",
        right: "97px",
        width: "56vw",
        height: "27vh",
        bottom: "39px",
      },
    },
    searchOrder: {
      display: "flex",
      [theme.breakpoints.down("xs")]: {
        position: "relative",
        left: "114px",
        marginTop: "68px",
      },
    },
    search: {
      marginLeft: "auto",
      marginRight: "15px",
      "& .MuiInputBase-input": {
        height: "0.1rem",
      },
      [theme.breakpoints.down("xs")]: {
        width: "140px",
        position: "absolute",
        right: "165px",
        bottom: "33px",
      },
    },
  })
);
